// bao migrate skip
import template from "./table-control-template.html";
import * as TableControl from "./table-control-module";
import * as ko from "knockout";
import Bao from "./../../services/bao-service";
export default {
    viewModel: {
        createViewModel: function (params, componentInfo) {
            var e = componentInfo.element;
            var vm = null;
            ko.utils.domNodeDisposal.addDisposeCallback(e, () => {
                if (vm != null) {
                    Bao.unbindEvent('table-control:load', vm.loadTableControlData);
                }
            });
            vm = new TableControl.TableControlComponent(params, componentInfo.element);
            return vm;
        }
    },
    template: template
};